import { render, staticRenderFns } from "./createCase.vue?vue&type=template&id=4f9f187e&scoped=true&"
import script from "./createCase.vue?vue&type=script&lang=js&"
export * from "./createCase.vue?vue&type=script&lang=js&"
import style0 from "./createCase.vue?vue&type=style&index=0&id=4f9f187e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f187e",
  null
  
)

export default component.exports